import { useEffect } from 'react'
export const GTMScript = () => {
  useEffect(() => {
    // FIXME: process.env.GTM_IDだとなぜかうまく取得できないので、一旦固定値で設定
    const gtmId = 'GTM-ZZ5VMKN'
    // 本番環境のみGTMスクリプトを読み込む
    if (process.env.GATSBY_STATS === 'production' && gtmId) {
      const loadHandler = () => {
        const script = document.createElement('script')
        script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
        script.defer = true
        document.body.appendChild(script)
        // オプショナル: データレイヤーの初期化
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js',
        })
        // noscript タグとその中の iframe を文字列として作成
        const noscriptHTML = `<noscript id="gtm-noscript"><iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display: none; visibility: hidden" aria-hidden="true"></iframe></noscript>`
        // noscript を body の最後に追加
        document.body.insertAdjacentHTML('beforeend', noscriptHTML)
        return () => {
          // コンポーネントのアンマウント時にスクリプトとnoscriptを削除
          document.body.removeChild(script)
          const noscript = document.getElementById('gtm-noscript')
          if (noscript) {
            document.body.removeChild(noscript)
          }
        }
      }
      if (document.readyState === 'complete') {
        // ページが既に完全にロードされている場合は、直接ハンドラを呼び出す
        loadHandler()
      } else {
        // それ以外の場合は、イベントリスナーを登録
        window.addEventListener('load', loadHandler)
        return () => {
          window.removeEventListener('load', loadHandler)
        }
      }
    }
    // 本番環境以外では何もしない
    return
  }, [])
  return null
}
